import { dispatchManagerFeatures } from '../../../featureFlags/dispatchManagerFeatures';
import { IShipmentLoadBoardViewItem } from '../../../api/shipment/interfaces';

export const getTrailerSize = (
    shipmentDetail: IShipmentLoadBoardViewItem,
    isAlterateDriver: boolean,
): string => {
    const { isTrailerSizePreferencesEnabled } = dispatchManagerFeatures;

    if (isTrailerSizePreferencesEnabled) {
        return getTrailerSizeFromRequirements(shipmentDetail, isAlterateDriver);
    }

    return getLegacyTrailerSize(shipmentDetail, isAlterateDriver);
};

const getLegacyTrailerSize = (
    shipmentDetail: IShipmentLoadBoardViewItem,
    isAlterateDriver: boolean,
): string => {
    const trailerSizes = [];

    if (
        shipmentDetail._49kTrucksRequired &&
        shipmentDetail._49kTrucksRequired > 0
    ) {
        trailerSizes.push(
            `TrailerSize ${isAlterateDriver ? 'ne' : 'eq'} '_49k'`,
        );
    }

    if (
        shipmentDetail._52kTrucksRequired &&
        shipmentDetail._52kTrucksRequired > 0
    ) {
        trailerSizes.push(
            `TrailerSize ${isAlterateDriver ? 'ne' : 'eq'} '_52k'`,
        );
    }

    if (
        shipmentDetail._55_62kTrucksRequired &&
        shipmentDetail._55_62kTrucksRequired > 0
    ) {
        trailerSizes.push(
            `TrailerSize ${isAlterateDriver ? 'ne' : 'eq'} '_55_62k'`,
        );
    }

    if (
        shipmentDetail._68kTrucksRequired &&
        shipmentDetail._68kTrucksRequired > 0
    ) {
        trailerSizes.push(
            `TrailerSize ${isAlterateDriver ? 'ne' : 'eq'} '_68k'`,
        );
    }

    if (trailerSizes.length > 0) {
        return 'and (' + trailerSizes.join(' or ') + ')';
    }

    return '';
};

const getTrailerSizeFromRequirements = (
    shipmentDetail: IShipmentLoadBoardViewItem,
    isAlterateDriver: boolean,
): string => {
    const { trailerRequirements } = shipmentDetail;

    if (!trailerRequirements || trailerRequirements.length === 0) {
        return '';
    }

    const uniqueNames = [
        ...new Set(
            trailerRequirements
                .filter(
                    truckSize => truckSize.trucksRequired > 0 && truckSize.name,
                )
                .map(truckSize => truckSize.name),
        ),
    ];

    if (uniqueNames.length === 0) {
        return '';
    }

    const filters = uniqueNames.map(
        name => `TrailerSize ${isAlterateDriver ? 'ne' : 'eq'} '${name}'`,
    );

    return 'and (' + filters.join(' or ') + ')';
};
